export class ExogenousLine {
  Name: string = null;
  Mnemonic: string = null;
  Group_ID: string = null;
  Display_Order: number = null;
  Account_Number: number = null;
  Description: string = null;
  Display_Format: string = null;
  Calculate_Group: number = null;
  Simulation_Order: string = null;
  Fail_Operator: string = null;
  Risk_Limit: string = null;
  // It is converted to a boolean for the back-end and is shown as "Yes" or "No" in the front-end
  Display_In_Summary: 'Yes' | 'No' | boolean = null;
}
